import axios from "../../axios";
import * as Requests from "../../requests";

export const deleteWorkingHoursScheduleApi = (token: string, scheduleId: string) => {
    return axios.delete(Requests.WORKING_HOURS_SCHEDULE_API(scheduleId), {
        headers: { token },
        baseURL: process.env.PICKUP_ENDPOINTS,
    });
};